import _toConsumableArray from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/core/postponed_operations.js)
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { Deferred, when } from "./utils/deferred";
import { isDefined } from "./utils/type";
export var PostponedOperations = /*#__PURE__*/function () {
  function PostponedOperations() {
    _classCallCheck(this, PostponedOperations);

    this._postponedOperations = {};
  }

  _createClass(PostponedOperations, [{
    key: "add",
    value: function add(key, fn, postponedPromise) {
      if (key in this._postponedOperations) {
        postponedPromise && this._postponedOperations[key].promises.push(postponedPromise);
      } else {
        var completePromise = new Deferred();
        this._postponedOperations[key] = {
          fn: fn,
          completePromise: completePromise,
          promises: postponedPromise ? [postponedPromise] : []
        };
      }

      return this._postponedOperations[key].completePromise.promise();
    }
  }, {
    key: "callPostponedOperations",
    value: function callPostponedOperations() {
      for (var key in this._postponedOperations) {
        var operation = this._postponedOperations[key];

        if (isDefined(operation)) {
          if (operation.promises && operation.promises.length) {
            when.apply(void 0, _toConsumableArray(operation.promises)).done(operation.fn).then(operation.completePromise.resolve);
          } else {
            operation.fn().done(operation.completePromise.resolve);
          }
        }
      }

      this._postponedOperations = {};
    }
  }]);

  return PostponedOperations;
}();